import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { SegmentHistoryApiResponse } from "../model/SegmentHistoryEntry";

export interface SegmentHistoryRequest {
  page: number;
  page_size?: number;
}

export const SegmentHistoryApiService = async (
  request: SegmentHistoryRequest
): Promise<SegmentHistoryApiResponse> => {
  const url = "/segments/change-log/";
  const { data } = await axios.get(url, {
    params: request,
  });
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useSegmentHistoryApiService = (request: SegmentHistoryRequest) =>
  useQuery<SegmentHistoryApiResponse, AxiosError>(
    ["SegmentHistoryApiService", request.page, request.page_size],
    () => SegmentHistoryApiService(request),
    { keepPreviousData: true }
  );

export default useSegmentHistoryApiService;
